export default {
  // administration: {
  //   users: 'EmptyLayout',
  //   roles: 'EmptyLayout',
  //   'users-groups': 'EmptyLayout',
  //   'safety-attributes': 'EmptyLayout',
  //   'safety-policy': 'EmptyLayout',
  // },
};
